import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {Box} from '@buncha/components/core/view';
import {CustomText} from '@buncha/components/core/text';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import {OrderHistory} from '@buncha/B2B/hooks/type';
import React from 'react';
import StepHeader from '../stepHeader/StepHeader';
import ViewOrderItemButton from '../viewOrderItemButton/ViewOrderItemButton';
import moment from 'moment';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface OrderPlaceStepProps {
  active: boolean;
  orderId: string;
  orderHistory?: OrderHistory;
  runId: number;
  legacyId: number;
  isCancelled?: boolean;
}

const OrderPlaceStep: React.FC<OrderPlaceStepProps> = ({
  active,
  orderId,
  orderHistory,
  runId,
  legacyId,
  isCancelled,
}) => {
  const theme = useColorThemeType();
  const muliFont = useFontTheme();
  const createdAt = orderHistory?.createdAt ?? '';
  const getDateString = isCancelled
    ? moment(createdAt).format('DD MMM YYYY, h:mm a')
    : moment(createdAt).format('hh:mm a');
  const timeStamp = createdAt?.length ? getDateString : '';
  const {title, body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};

  return (
    <Box style={styles.container}>
      <StepHeader textTitle={title?.orderPlace} timeString={timeStamp} />
      <If condition={active}>
        <Box style={styles.activeContainer}>
          <CustomText
            style={[
              styles.infoText,
              {
                color: theme?.text.blue[300],
                fontFamily: muliFont[400].normal,
              },
            ]}>
            {body?.shoppingSoon}
          </CustomText>
          <Box style={styles.buttonWrapper}>
            <ViewOrderItemButton
              orderId={orderId}
              runId={runId}
              legacyId={legacyId}
            />
          </Box>
        </Box>
      </If>
    </Box>
  );
};

export default React.memo(OrderPlaceStep);
